/**
 * scienceThresholds — научные пороги UI в одном месте (W-FIX: аудит
 * 2026-07-04 нашёл их разбросанными по компонентам как магические числа).
 *
 * Это методология, не вкусовщина — источники в drill-content.ts.
 * TODO(backend): вынести в конфиг `/athlete/thresholds`, чтобы тренер /
 * тир мог переопределять; пока — единая точка правды на фронте.
 */

/** Границы тона readiness-score (ReadinessRing, риск-чипы). */
export const READINESS_BANDS = {
  bright: 85,
  green: 70,
  amber: 50,
} as const;

/** TSB: ниже first — «глубокая усталость», ниже second — «внимание». */
export const TSB_DEEP_FATIGUE = -15;
export const TSB_CAUTION = -5;

/**
 * Безопасный набор формы за неделю, пункты CTL.
 *
 * Зеркало `shared/services/goal_periodization.SAFE_WEEKLY_CTL_RAMP` — по нему
 * же рисуется коридор роста на кривой формы. Заведено 2026-08-04: тренд CTL
 * красился зелёным по одному знаку прироста, и «+4.1 за неделю» хвалили ровно
 * в тот момент, когда карточка выше писала «Ramp 15.8%/нед — притормози рост».
 * Цвет и текст обязаны спрашивать одну границу.
 */
export const SAFE_WEEKLY_CTL_RAMP = 3.0;

/**
 * Доля мощности «с датчика», ниже которой порогам по мощности верить
 * нельзя.
 *
 * Половина взята не как круглое число: FTP и всё производное считаются по
 * вершинам кривой мощности, и когда больше половины тренировок несут
 * ОЦЕНКУ алгоритма, вершина с большой вероятностью тоже оценка.
 *
 * Зеркало `POWER_TRUST_FLOOR_PCT` в тренерской аппе
 * (`admin/src/components/SensorCoverageCard.tsx`) — приложения не делят
 * код, поэтому число живёт в двух местах; правишь одно — правь второе.
 * Разъехавшись, роли разойдутся в том, кому из них верить.
 */
export const POWER_TRUST_FLOOR_PCT = 50;

/** Seiler 80/20: поляризованное распределение зон (низ/верх/середина, %). */
export const POLARIZED = { low: 75, high: 15, midMax: 10 } as const;
/** Преимущественно аэробное распределение (низ, %). */
export const AEROBIC_LOW = 70;
/** Пирамидальное: доля середины (%), выше которой это «пирамида». */
export const PYRAMID_MID = 30;

/** Питание: от скольки минут тренировки показываем carb-план. */
export const CARB_FUELING_MIN_DURATION_MIN = 45;

/** Вероятность осадков (%), с которой предупреждаем в протоколе. */
export const PRECIP_WARN_PROB = 30;

/** За сколько дней предупреждать о смене фазы мезоцикла. */
export const PHASE_LOOKAHEAD_DAYS = 14;

/** TSB, ниже которого вечерний блок советует +30′ сна. */
export const SLEEP_EXTRA_TSB = -10;
